var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('fa-icon',{attrs:{"icon":"gear"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.layer.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }